import GnlParametreDTO from "src/models/GnlParametre/GnlparametreDTO";
import api from "../core/api";
import { ApiRequest } from "src/models/api.request";
import GnlParametreGrupDTO from "src/models/GnlParametre/GnlparametregrupDTO";

const controllerName1 = "GnlParametreGrupDTO";
const controllerName2 = "GnlParametreDTO";

const ParametreTanimApi = api.injectEndpoints({
    endpoints: (builder) => ({
        ParametreListesi: builder.query<Array<GnlParametreGrupDTO>, void>({
            query: (request) => {
                var req: ApiRequest<GnlParametreGrupDTO> = {
                    sorts: [{ fieldName: "id", ascending: false }],
                };
                return {
                    url: controllerName1 + "/find",
                    method: "POST",
                    body: JSON.stringify(req)
                }
            },
            providesTags: ["ParametreTanim"]
        }),
        ParametreEkle: builder.mutation<GnlParametreGrupDTO, GnlParametreGrupDTO>({
            query: (request) => {
                return {
                    url: controllerName1,
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["ParametreTanim"]
        }),
        ParametreGuncelle: builder.mutation<GnlParametreGrupDTO, GnlParametreGrupDTO>({
            query: (request) => {
                return {
                    url: controllerName1,
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["ParametreTanim"]
        }),
        ParametreSil: builder.mutation<GnlParametreGrupDTO, number>({
            query: (id) => {
                return {
                    url: controllerName1 + "/" + id,
                    method: "DELETE"
                }
            },
            invalidatesTags: ["ParametreTanim"]
        }),
        ParametreDetayListesi: builder.query<Array<GnlParametreDTO>, { grupId: number, iptal: string }>({
            query: (request) => {
                var req: ApiRequest<GnlParametreDTO> = {
                    sorts: [{ fieldName: "id", ascending: false }],
                    filters: {
                        groupOperator: "and",
                        predicates: [
                            { fieldName: "grupId", operator: "=", value1: request.grupId }
                        ]
                    }
                };
                if (request.iptal)
                    req.filters.predicates.push({ fieldName: "aktif", operator: "=", value1: request.iptal });
                return {
                    url: controllerName2 + "/find",
                    method: "POST",
                    body: JSON.stringify(req)
                }
            },
            providesTags: ["ParametreTanimDetay"]
        }),
        ParametreDetayEkle: builder.mutation<GnlParametreDTO, GnlParametreDTO>({
            query: (request) => {
                return {
                    url: controllerName2,
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["ParametreTanimDetay"]
        }),
        ParametreDetayGuncelle: builder.mutation<GnlParametreDTO, GnlParametreDTO>({
            query: (request) => {
                return {
                    url: controllerName2,
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            },
            invalidatesTags: ["ParametreTanimDetay"]
        }),
        ParametreDetaySil: builder.mutation<GnlParametreDTO, number>({
            query: (id) => {
                return {
                    url: controllerName2 + "/" + id,
                    method: "DELETE"
                }
            },
            invalidatesTags: ["ParametreTanimDetay"]
        }),
    })
});

export const {
    useParametreListesiQuery,
    useParametreEkleMutation,
    useParametreGuncelleMutation,
    useParametreSilMutation,
    useParametreDetayListesiQuery,
    useParametreDetayEkleMutation,
    useParametreDetayGuncelleMutation,
    useParametreDetaySilMutation
} = ParametreTanimApi;